import { render } from "./transfer_from_w_history.vue?vue&type=template&id=2f300137&scoped=true"
import script from "./transfer_from_w_history.vue?vue&type=script&lang=js"
export * from "./transfer_from_w_history.vue?vue&type=script&lang=js"

import "./transfer_from_w_history.vue?vue&type=style&index=0&id=2f300137&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f300137"]])

export default __exports__